import { Constants } from "../../constants/constants";
import { ServiceOrganizationAction } from "../../constants/enums";
import IdentityClient from "./IdentityClient";

interface IRequestAddServiceOrganization {
    organizations: {
        organizationId: number;
        action: ServiceOrganizationAction;
    }[];
    clientId: string;
}

const ServiceOrganizationService = {
    async add(data: IRequestAddServiceOrganization) {
        const result = await IdentityClient().post(Constants.ApiPath.SERVICE_ORGANIZATION.ADD, data);
        return result.data.result;
    },
};

export default ServiceOrganizationService;
